module.exports = __webpack_public_path__ + "img/baxiQR.2001ba0d.jpg";